export function createSvg(width: number, height: number): SVGSVGElement {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg") as SVGSVGElement;
  svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  svg.setAttribute("width", String(width));
  svg.setAttribute("height", String(height));
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);

  svg.style.position = "absolute";
  svg.style.visibility = "hidden";
  document.body.appendChild(svg);

  const bg = document.createElementNS(svg.namespaceURI, "rect");
  bg.setAttribute("width", String(width));
  bg.setAttribute("height", String(height));
  bg.setAttribute("fill", "#000");
  svg.appendChild(bg);

  return svg;
}

export function serializeSvg(svg: SVGSVGElement): Blob {
  document.body.removeChild(svg);
  svg.style.position = "";
  svg.style.visibility = "";
  return new Blob([new XMLSerializer().serializeToString(svg)], {type: "image/svg+xml"});
}